import {h, Component} from 'preact';
import style from './style.scss'

export default class OfflineMessage extends Component{
    render(){
        var forms = this.props.entry.meta.details.forms
            return (
            <div className={style.MetaOffline}>
                Meddelande skickat via offline-formulär
                {Object.keys(forms).map( (key, i) => {
                    if(forms[key]){
                        return (
                            <input key={i} value={forms[key]} disabled/>
                        )
                    }
                    return ''

                })
                }
                <textarea
                    className={style.MetaOfflineTextArea}
                    disabled
                    resize='none'
                    value={this.props.entry.entry_body}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./routes/Chat/Chat/MetaMessage/OfflineMessage.js